export default __webpack_public_path__ + "static/media/Sova-LineupCover.8bced8b3.png";